import { useEffect, useState } from 'react';
import moment from 'moment';
// triggers next sponsor sequence
export const useAdLoop = (currentPeriod, dispatch, secondsSinceCurrentPeriodStart) => {
    const [running, setRunning] = useState(false);
    const [allowedSizes, setSizes] = useState(undefined);
    const [config, setConfig] = useState(undefined);
    const start = (config, allowedSizes) => {
        setSizes(allowedSizes);
        setConfig(config);
        setRunning(true);
    };
    const stop = () => {
        setSizes(undefined);
        setRunning(false);
    };
    // should pull this all out of the archive?????
    const [last, setLast] = useState({
        secsSinceStart: secondsSinceCurrentPeriodStart || 0,
        date: moment()
            .subtract(10, 'seconds')
            .toDate()
    });
    // This defines the rate based on overall period. Will not show full x if part of the match is missed.
    useEffect(() => {
        if (!currentPeriod || !config || !dispatch || !running || !secondsSinceCurrentPeriodStart) {
            return;
        }
        const date = new Date();
        if ((config === null || config === void 0 ? void 0 : config.type) === 'xPerPeriod') {
            const totalPeriodDuration = ((currentPeriod === null || currentPeriod === void 0 ? void 0 : currentPeriod.duration) - 1) * 60;
            const totalDurationAdShows = config.secsPerShow * config.perPeriod;
            const secsBetweenShows = (totalPeriodDuration - totalDurationAdShows) / config.perPeriod;
            if ((secondsSinceCurrentPeriodStart || 0) - last.secsSinceStart > secsBetweenShows + config.secsPerShow) {
                dispatch(config.secsPerShow, allowedSizes);
                setLast({ secsSinceStart: secondsSinceCurrentPeriodStart, date });
            }
        }
        // 'everyXSecs'
        else if ((date.getTime() - last.date.getTime()) / 1000 > (config === null || config === void 0 ? void 0 : config.secsBetweenShows) + config.secsPerShow) {
            dispatch(config.secsPerShow, allowedSizes);
            // trigger and then setLast
            setLast({ secsSinceStart: secondsSinceCurrentPeriodStart, date: new Date() });
        }
    }, [secondsSinceCurrentPeriodStart, config, dispatch, currentPeriod, running]);
    return { start, stop, running };
};
//# sourceMappingURL=useAdLoop.js.map